import styled from 'styled-components';
import { SPACING } from '~/common/layout-propertis/spacing';

export const StyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._32};
`;

export const StyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
`;
